// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"1ac6643f","736":"0f617f3a"}[chunkId] + ".chunk.js";
};